import { Component, ChangeDetectionStrategy, inject, afterRenderEffect, signal, untracked } from '@angular/core';
import { LocationService } from '../../../location.service';
import { MenuGridComponent } from '../menu-grid/menu-grid.component';

@Component({
  selector: 'menu-browser',
  templateUrl: './menu-browser.component.html',
  styleUrls: ['./menu-browser.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MenuGridComponent],
})
export default class MenuBrowserComponent {
  router = inject(LocationService);

  search = signal<string>('');
  sort = signal<'popularity' | 'search'>('popularity');

  constructor(){

    afterRenderEffect(() => {
      const search = this.search();

      untracked(() => {
        if(!search){
          this.sort.set('popularity');
        } else {
          if(search.toUpperCase().startsWith('MT') && (search.length == 7 || search.length == 10)){
            this.router.navigate(['/menus/store', search.toUpperCase()]);
            return;
          }
          this.sort.set('search');
        }
      });
    });
  }

}
